import _ from "lodash";

import * as DateUtils from "../../../utils/date/date";
import { CalcOperation } from "./ProcessorCalculatingMachine/Operators/CalcOperations";

import {
    AccountingMachine,
    FinancerMachine,
    FinancialMachine,
    PersonnelMachine,
    TaxMachine
} from "./ProcessorCalculatingMachine";

export class CalculatingMachineMiddleware {
    constructor(Serie) {
        this.ProcessorCalculatingMachine = null;

        this.Serie = Serie;

        this.period = "monthly";
    }

    setSource(source = "accounting") {
        if (source === "custom") source = "accounting";

        const processorMachines = {
            accounting: () => {
                this.ProcessorCalculatingMachine = new AccountingMachine({
                    Serie: this.Serie
                });
            },
            financial: () => {
                this.ProcessorCalculatingMachine = new FinancialMachine({
                    Serie: this.Serie
                });
            },
            personnel: () => {
                this.ProcessorCalculatingMachine = new PersonnelMachine({
                    Serie: this.Serie
                });
            },
            eSocial: () => {
                this.ProcessorCalculatingMachine = new PersonnelMachine({
                    Serie: this.Serie
                });
            },
            tax: () => {
                this.ProcessorCalculatingMachine = new TaxMachine({
                    Serie: this.Serie
                });
            },
            simplesNacional: () => {
                this.ProcessorCalculatingMachine = new TaxMachine({
                    Serie: this.Serie
                });
            },
            fin: () => {
                this.ProcessorCalculatingMachine = new FinancerMachine({
                    Serie: this.Serie
                });
            }
        };

        this.source = source;

        processorMachines[source]();
    }

    getDatesAvailable(points) {
        let allYears = points.map((point) => {
            if (point.t) return DateUtils.dateToString(point.t, "yyyy");
        });
        if (!allYears.length) {
            allYears = [DateUtils.dateToString(new Date(), "yyyy")];
        }

        const currentYear = DateUtils.dateToString(new Date(), "yyyy");

        const _years = _.uniq(allYears);
        let years = _years.sort();

        const firstYear = _.head(years);
        const lastYear = currentYear + 1;

        const interactions = lastYear - firstYear + 1;

        let yearsToConsolidate = Array.from(
            { length: interactions },
            (v, k) => firstYear + k
        );

        const yearsMonthFormated = yearsToConsolidate.reduce((acc, year) => {
            const monthsFormated = Array.from({ length: 12 }, (v, k) =>
                DateUtils.dateToString(
                    DateUtils.getStartOfMonth(`${year}-${k + 1}`),
                    "yyyy-MM"
                )
            );
            return acc.concat(monthsFormated);
        }, []);

        return yearsMonthFormated;
    }

    /**
     * @public
     * Método para buscar points no intervalo escolhido Monthly, quarterly, yearly
     * @param {Array} points
     * @return {Array} pointsInterval
     */
    formatPeriodPoints(
        points,
        availables,
        period,
        serieIds,
        scenario = "ORIGINAL"
    ) {
        if (_.isEmpty(points)) return [];

        const months = {
            quarterly: [3, 6, 9, 12],
            semester: [6, 12],
            yearly: [12]
        };

        if (period === "monthly") return points;

        const availablesFilterByPeriod = _.filter(availables, (av) =>
            _.includes(
                months[period],
                parseInt(DateUtils.dateToString(av, "M"))
            )
        );

        const pointsFormatedResult = _.reduce(
            serieIds,
            (pointsFormated, serie) => {
                const pointsListBySerieId = _.filter(
                    points,
                    (p) => p.s === serie
                );
                pointsFormated = _.concat(pointsFormated, pointsListBySerieId);
                _.map(availablesFilterByPeriod, (availableFiltred) => {
                    let time = DateUtils.getDate(availableFiltred);
                    let point = _.find(
                        pointsListBySerieId,
                        (p) => time.getTime() === p.t.getTime()
                    );

                    if (!point) {
                        pointsFormated.push({
                            c: "EMPRESA_NUCONT",
                            m: { v: 0 },
                            s: serie,
                            period: this.period,
                            sc: scenario,
                            t: time
                        });
                    }
                });

                return pointsFormated;
            },
            []
        );

        return pointsFormatedResult;
    }

    filterPoints(points, entryDate, selectedDate, period, ignoreAvailable) {
        if (!entryDate || points.length === 0) return [];

        const months = {
            quarterly: [3, 6, 9, 12],
            semester: [6, 12],
            yearly: [12]
        };

        const isMonthly = period === "monthly";
        const filteredPoints = [];
        const periodMonths = isMonthly ? null : months[period];

        for (const point of points) {
            const date = point.t;
            const month = new Date(date).getMonth() + 1;

            if (
                (isMonthly || periodMonths.includes(month)) &&
                (ignoreAvailable || (date >= entryDate && date <= selectedDate))
            ) {
                filteredPoints.push(point);
            }
        }

        return filteredPoints.sort((a, b) => a.t - b.t);
    }

    valueGet(serie, point, financialSettings = {}, opt = {}) {
        let pointValue = 0;
        if (_.isEmpty(serie) || _.isEmpty(point)) return pointValue;
        if (serie?.origin === "goals") {
            return _.get(point, "m.c", 0);
        }

        let source = _.isArray(serie.sources)
            ? _.head(serie.sources)
            : serie.sources;

        let isAccountResult =
            source === "accounting" &&
            parseInt(_.get(serie, "classifier", "").toString().charAt(0)) >= 3;

        if (opt.accountsPlan && _.get(point, "sc") === "ORIGINAL") {
            if (isAccountResult) {
                pointValue = _.get(point, "m.f", 0) - _.get(point, "m.o", 0);
            } else if (serie.exp) {
                pointValue = _.get(point, "m.v", 0);
            } else {
                pointValue = _.get(point, "m.f", 0);
            }
            const need =
                opt.hasOwnProperty("applyEffect") && opt.applyEffect === true;
            if (need) return this._effectsApply(pointValue, serie);
            return pointValue;
        }

        if (serie.exp && serie.type !== "raw")
            pointValue = _.get(point, "m.v", 0);
        else if (
            opt.hasOwnProperty("parameterizationNotAccumulated") &&
            opt.parameterizationNotAccumulated === false
        )
            pointValue = _.get(point, "m.f", 0);
        else {
            const { isAccumulated } = opt;

            if (
                isAccumulated === false ||
                ((source === "custom" ||
                    isAccountResult ||
                    serie.type === "dre") &&
                    point.sc === "ORIGINAL" &&
                    this.period === "monthly" &&
                    !opt.accumulated)
            ) {
                pointValue = _.isFinite(_.get(point, "m.f", Infinity))
                    ? _.get(point, "m.f", 0) - _.get(point, "m.o", 0)
                    : _.get(point, "m.v", 0);
            } else {
                pointValue = _.isFinite(_.get(point, "m.v", Infinity))
                    ? _.get(point, "m.v", 0)
                    : _.get(point, "m.f", _.get(point, "m.r", 0));
            }
        }

        if (opt.monthlyFinancialCalc && !point.cashflow) {
            let pointPreviousFinancialVal = this._findPreviousPointVal(
                financialSettings
            );

            pointValue = pointValue - pointPreviousFinancialVal;
        }

        if (opt.hasOwnProperty("applyEffect") && opt.applyEffect === true) {
            return this._effectsApply(pointValue, serie);
        }

        return pointValue;
    }

    _findPreviousPointVal(financialSettings) {
        const { points, date } = financialSettings;

        if (
            !date ||
            _.isEmpty(points) ||
            parseInt(DateUtils.dateToString(date, "M")) === 1
        )
            return 0;

        const previousPoint = _.find(points, {
            t: new Date(CalcOperation.helperMonths(date, -1))
        });

        return _.isFinite(_.get(previousPoint, "m.f", Infinity))
            ? _.get(previousPoint, "m.f", 0)
            : _.get(previousPoint, "m.v", 0);
    }

    comparation({
        companyId,
        series,
        xFilter,
        yFilter,
        accumulated,
        isGroupCompanies,
        options
    }) {
        const getResultComparation = ({
            companyId,
            serieId,
            scenarioId,
            period,
            dates,
            options
        }) => {
            return this.resultComparation({
                companyId,
                serieId,
                scenario: scenarioId,
                period,
                timesBetween: {
                    startDate: dates[0],
                    endDate: dates[1]
                },
                options: {
                    isGroupCompanies,
                    visualizationAccumulated: accumulated,
                    ...options
                }
            });
        };

        const points = [];

        const dates = [xFilter.date, yFilter.date].sort((a, b) => a - b);
        const isMonthly = this.period === "monthly";

        for (const serie of series) {
            const _pointsFilterX = getResultComparation({
                companyId,
                serieId: serie._id,
                scenarioId: xFilter.scenario._id,
                period: xFilter.period,
                dates,
                options
            });

            const _pointsFilterY = getResultComparation({
                companyId,
                serieId: serie._id,
                scenarioId: yFilter.scenario._id,
                period: yFilter.period,
                dates,
                options
            });

            let xPoint = {};

            try {
                xPoint = _pointsFilterX.find(
                    (point) =>
                        point.t === 0 ||
                        point.t.getTime() === xFilter.date.getTime()
                );
            } catch (error) {}

            const yPoint = _pointsFilterY.find(
                (point) =>
                    point.t === 0 ||
                    point.t.getTime() === yFilter.date.getTime()
            );

            const _pointValueX = isMonthly
                ? this.valueGet(serie, xPoint, {}, { accumulated })
                : _.get(xPoint, "m.v", 0);

            const _pointValueY = isMonthly
                ? this.valueGet(serie, yPoint, {}, { accumulated })
                : _.get(yPoint, "m.v", 0);

            const value = _pointValueX - _pointValueY;

            const percentage =
                isNaN(_pointValueY) || _pointValueY === 0
                    ? 0
                    : value / _pointValueY;

            const variationCondition = this.variationCondition(
                _pointValueX,
                _pointValueY,
                serie.polarity
            );

            points.push({
                ...serie,
                current: _pointValueX,
                prev: _pointValueY,
                value,
                percentage,
                period: xFilter,
                comparation: yFilter,
                progress: this.variationProgressBar(_pointValueX, _pointValueY),
                variationCondition,
                polarityColor: this.polarityColor(
                    {
                        polarity: serie.polarity,
                        current: _pointValueX,
                        prev: _pointValueY,
                        value
                    },
                    true,
                    variationCondition
                )
            });
        }

        return points;
    }

    polarityColor = (
        data = { polarity, current, prev, value },
        dot = true,
        direction
    ) => {
        if (!data) return !dot ? "basic-medium" : "basic.medium";
        if (data.value === 0) return !dot ? "basic-medium" : "basic.medium";
        let color = "purple.dark";
        if (direction) {
            if (data.polarity == 1) {
                color = "cyan.dark";
            } else {
                color = "purple.dark";
            }
        } else {
            if (data.polarity == 1) {
                color = "purple.dark";
            } else {
                color = "cyan.dark";
            }
        }
        return !dot ? color.replace(/[.]/g, "-") : color;
    };

    /**
     * @public
     * @param {Number} current
     * @param {Number} prev
     * @return {Ojbect} retonar o percentual da variação
     */
    _calcVariation(current, prev) {
        /**
         * Retorna variacao para preencher a barra
         * @param {Number} current atual
         * @param {Number} prev anterior
         * @returns {Number} resultado
         */
        const _fixProgress = (current, prev) => {
            let result = 0;

            if (prev > 0 && current > 0) result = (current - prev) / prev;
            else if (prev < 0 && current > 0)
                result = (current + Math.abs(prev)) / Math.abs(prev);
            else if (prev > 0 && current < 0)
                result = -Math.abs((Math.abs(current) + prev) / prev);
            else if (prev < 0 && current < 0) {
                if (current > prev) result = Math.abs((current - prev) / prev);
                else result = -Math.abs((current - prev) / prev);
            }

            return result;
        };

        /**
         * Retorna variacao para exibir o valor
         * @param {Number} current atual
         * @param {Number} prev anterior
         * @returns {Number} resultado
         */

        const _fixValue = (current, prev) => {
            let result = 0;

            if (prev > 0 && current > 0)
                result = ((current - prev) / prev) * 100;
            else if (prev < 0 && current > 0)
                result = ((current + Math.abs(prev)) / Math.abs(prev)) * 100;
            else if (prev > 0 && current < 0)
                result = (-Math.abs(Math.abs(current) + prev) / prev) * 100;
            else if (prev < 0 && current < 0) {
                if (current > prev)
                    result = Math.abs((current - prev) / prev) * 100;
                else result = -Math.abs((current - prev) / prev) * 100;
            }

            return result < 0 ? result * -1 : result;
        };

        const zero = {
            value: 0,
            percent: 0,
            percentView: 0
        };

        if (current == 0 && prev == 0) return zero;

        return {
            value: current - prev,
            percent: _fixProgress(current, prev),
            percentView: _fixValue(current, prev)
        };
    }

    /**
     * @public
     * Gera barra progress
     * @param {Number} current atual
     * @param {Number} prev anterior
     * @return {Integer}
     */
    variationProgressBar(current, prev) {
        let variation = this._calcVariation(current, prev),
            progress = (0.5 + variation.percent / 2) * 100;

        if (
            variation.value == 0 &&
            variation.percent == 0 &&
            variation.percentView == 0
        )
            return 0;

        if (progress < 0) return 0;

        if (progress > 100) return 100;

        return progress;
    }

    /**
     * @public
     * Retorna o resultado da variação de acordo com a polaridade
     * @param {Number} x
     * @param {Number} y
     * @param {String} polarity
     * @returns
     */
    variationCondition(x, y, polarity) {
        if (polarity < 0) {
            x = Math.abs(x);
            y = Math.abs(y);
        }
        if (x == y) return false;
        let p = false;

        if (
            (x < 0 && y < 0 && x < y) ||
            (x > 0 && y > 0 && x < y) ||
            (x < 0 && y > 0) ||
            (x === 0 && y > 0)
        ) {
            //ABAIXO
            p = false;
        } else if (
            (x < 0 && y < 0 && x > y) ||
            (x > 0 && y > 0 && x > y) ||
            (x > 0 && y <= 0) ||
            (x === 0 && y < 0)
        ) {
            //ACIMA
            p = true;
        }

        return p;
    }

    generateFakePoints({ serieIds, timesBetween }) {
        serieIds = [].concat(serieIds);
        let points = [];

        let year = new Date().getFullYear();

        timesBetween = {
            startDate: new Date(year + "/01/01"),
            endDate: new Date(year + "/12/01")
        };

        const dates = DateUtils.getDatesInterval(
            timesBetween.startDate,
            timesBetween.endDate
        );

        for (let index = 0; index < serieIds.length; index++) {
            const serieId = serieIds[index];
            for (let dateIndex = 0; dateIndex < dates.length; dateIndex++) {
                const date = dates[dateIndex];

                const value = Math.floor(Math.random() * 100000 + 10000);

                points.push({
                    s: serieId,
                    t: date,
                    m: { v: value, f: value, m: value },
                    c: "EMPRESA_NUCONT",
                    period: "monthly",
                    sc: "ORIGINAL"
                });
            }
        }

        return points;
    }

    _effectsApply(pointValue, serie) {
        let serieEffect = _.get(serie, "metadata.negative", false)
            ? "negative"
            : _.get(serie, "metadata.positive", false) ||
              _.get(serie, "metadata.reducing", null)
            ? "positive"
            : "default";

        if (!pointValue) return 0;

        const _effectApplier = {
            positive: (value) => Math.abs(value),
            negative: (value) => -1 * value,
            default: (value) => value
        };

        const pointValueEffect = _effectApplier[serieEffect](pointValue);

        return pointValueEffect;
    }
}
